import { Feedback, TypeArray, Jump } from "../types"
import { reducerTypeGuard } from "../reducers/reducerGuards"
import { actionCreatorTypeGuard } from "../reducers/actionCreators"
import {
  processActionMeta,
  getArrayTypeReducerGuard,
  getObjectTypeReducerGuard
} from "../reducers"

export type Other = {
  feedbacks: Array<Feedback>
  jump: Jump | null
}

const reducerAction = {
  feedbacks: actionCreatorTypeGuard<Other, Array<Feedback>>(
    "feedbacks",
    "Other"
  ),
  jump: actionCreatorTypeGuard<Other, Jump | null>("jump", "Other"),
  __record: actionCreatorTypeGuard<TypeArray, Other>("Other", "__record"),
  __create: actionCreatorTypeGuard<TypeArray, null | Partial<Other>>(
    "create",
    "__create/Other"
  ),
  __null: actionCreatorTypeGuard<TypeArray, null>("null", "__record")
}

// Type safety to ensure we have a defined action for each property
type ReducerActions = {
  [key in
    | keyof Other
    | "__record"
    | "__null"
    | "__create"]: (typeof reducerAction)[key][0]
}

// Our exported actions
export const otherAction = Object.fromEntries(
  Object.entries(reducerAction).map(k => [k[0], k[1][0]])
) as ReducerActions

export const otherReducer = reducerTypeGuard<Other>()
  .case(...reducerAction.feedbacks)
  .case(...reducerAction.jump)
  .default((prevState, action: any) => {
    action = processActionMeta(action)

    switch (action?.meta?.prop) {
      case "feedbacks":
        return getArrayTypeReducerGuard<Other, Feedback>(
          "other",
          "feedbacks",
          "Feedback",
          prevState,
          action
        )
      case "jump":
        return getObjectTypeReducerGuard<Other, Jump | null>(
          "other",
          "jump",
          "Jump",
          prevState,
          action
        )
    }

    return prevState
  })
